import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import ReactDrawer from "react-drawer";
import "react-drawer/lib/react-drawer.css";
import UserProfile from "../../pages/Authentication/UserProfile";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      position: "right",
      // profile: []
    };
    this.refDiv = React.createRef();
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
    this.setPosition = this.setPosition.bind(this);
  }

  componentDidMount() {
    this.initMenu();
    // const userData = getUserName();
    // if (userData) {
    //   this.setState({ profile: userData.result });
    // }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
      // const userData = getUserName();
      // if (userData) {
      //   this.setState({ profile: userData.result });
      // }
    }
  }

  setPosition(e) {
    this.setState({ position: e.target.value });
  }
  toggleRightDrawer() {
    this.setState({ position: "right" });
    this.setState({ open: !this.state.open });
  }
  closeDrawer() {
    this.setState({ open: false });
  }
  onDrawerClose() {
    this.setState({ open: false });
  }

  initMenu() {
    new MetisMenu("#side-menu");
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  scrollElement = (item) => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    const { profileData } = this.props;
    const perms = Object.fromEntries(profileData.permissions.map(p => [p, true]));
    return (
      <React.Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled " id="side-menu">
              <li>
                <Link to="/dashboard" className="font-size-16">
                  <i className="fas fa-home" />
                  <span>{this.props.t("Dashboard")}</span>
                </Link>
              </li>
              {/* Profile Tab */}
              <li>
                <Link to="#" className="font-size-16 has-arrow">
                  <i className="fas fa-user-ninja" />
                  <span>{this.props.t("Profile")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link
                      to="#"
                      className="font-size-14"
                      onClick={this.toggleRightDrawer}
                      disabled={this.state.open}
                    >
                      {this.props.t("Profile")}
                    </Link>
                  </li>
                  {perms.leavesOverallAccess && (
                    <>
                      <li>
                        <Link to="/leave_apply" className="font-size-14">
                          {this.props.t("Apply for leave")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/leave_approve" className="font-size-14">
                          {this.props.t("Leave Approval")}
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </li>
              {/* Battlefield Tab  */}
              {perms.battlefieldAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-yin-yang" />
                    <span>{this.props.t("Battlefield Orders")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/battlefield" className="font-size-14">
                        {this.props.t("Battlefield")}
                      </Link>
                    </li>
                    {/* {perms.battlefieldPayoneerAccess && (
                      <li>
                        <Link to="/payoneer_requests" className="font-size-14">
                          {this.props.t("Payoneer Payment Requests")}
                        </Link>
                      </li>
                    )} */}
                    <li>
                      <Link to="/lost_orders" className="font-size-14">
                        {this.props.t("Lost Orders")}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {/* CRM tab */}
              {/* <li>
                <Link to='/leads' className='font-size-16 has-arrow'>
                  <i className='fas fa-yin-yang' />
                  <span>{this.props.t('CRM')}</span>
                </Link>
              </li> */}
              {/* Priority Tab  */}
              {perms.priorityOrderAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-warehouse" />
                    <span>{this.props.t("Priority Orders")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {(perms.priorityOrderKrAccess ||
                      profileData.accType === "Admin") && (
                      <li>
                        <Link to="/priority" className="font-size-14">
                          {this.props.t("Priority Korea")}
                        </Link>
                      </li>
                    )}
                    {profileData.department.depName !==
                      "Cosmetic Brand-Suppuru" && (
                      <>
                        {perms.priorityOrderUkAccess && (
                          <li>
                            <Link
                              to="/priority_ukraine"
                              className="font-size-14"
                            >
                              {this.props.t("Priority Ukraine")}
                            </Link>
                          </li>
                        )}

                        {(perms.priorityOrderMscAccess ||
                          profileData.accType === "Admin") && (
                          <li>
                            <Link
                              to="/priority_moscow"
                              className="font-size-14"
                            >
                              {this.props.t("Priority Moscow")}
                            </Link>
                          </li>
                        )}

                        {(perms.priorityOrderUaeAccess ||
                          profileData.accType === "Admin") && (
                          <li>
                            <Link to="/priority_uae" className="font-size-14">
                              {this.props.t("Priority UAE")}
                            </Link>
                          </li>
                        )}

                        {(perms.priorityOrderPlAccess ||
                          profileData.accType === "Admin") && (
                          <li>
                            <Link to="/priority_pl" className="font-size-14">
                              {this.props.t("Priority Poland")}
                            </Link>
                          </li>
                        )}

                        {(perms.priorityOrderUsaAccess ||
                          profileData.accType === "Admin") && (
                          <li>
                            <Link to="/priority_usa" className="font-size-14">
                              {this.props.t("Priority USA")}
                            </Link>
                          </li>
                        )}
                        {(perms.customerServiceAccess ||
                          profileData.accType === "Admin") && (
                          <li>
                            <Link
                              to="/customer_service"
                              className="font-size-14"
                            >
                              {this.props.t("Customer Service")}
                            </Link>
                          </li>
                        )}
                      </>
                    )}
                  </ul>
                </li>
              )}
              {perms.inventoryAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i
                      className="mdi mdi-inbox-multiple"
                      style={{ fontSize: "24px" }}
                    />
                    <span>{this.props.t("#7 Ru, Moscow, Safekeeping")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {perms.inventoryAccess && (
                      <li>
                        <Link to="/inventory_moscow" className="font-size-14">
                          {this.props.t("Inventory #7 Russia, Moscow")}
                        </Link>
                      </li>
                    )}
                    {perms.shipAppwh7Access && (
                      <li>
                        <Link to="/shipping_moscow" className="font-size-14">
                          {this.props.t("Shipping Application #7 Moscow")}
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* Transfers Tab  */}
              {perms.transferAgentAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-people-arrows" />
                    <span>{this.props.t("Transfer Agent")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/transfers" className="font-size-14">
                        {this.props.t("Transfers Europe")}
                      </Link>
                    </li>

                    <li>
                      <Link to="/agents" className="font-size-14">
                        {this.props.t("Agents Info")}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {/* Calculator Tab  */}
              {perms.shippingCalcAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-calculator" />
                    <span>{this.props.t("Calculators")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/calculator_europe" className="font-size-14">
                        {this.props.t("Shipping Europe Calculator")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/calculator_fedex" className="font-size-14">
                        {this.props.t("Fedex Calculator")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/calculator_wroclaw" className="font-size-14">
                        {this.props.t("Poland  Calculator")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/calculator_info" className="font-size-14">
                        {this.props.t("Shipping Info")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link to='/msk_data' className='font-size-14'>
                        {this.props.t('Moscow Shipping Info')}
                      </Link>
                    </li> */}
                  </ul>
                </li>
              )}
              {/* Price List Tab  */}
              {perms.priceLstAccessView && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-tags" />
                    <span>{this.props.t("Price List")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/price_list" className="font-size-14">
                        {this.props.t("Price List")}
                      </Link>
                    </li>
                    {perms.priceLstAccess && (
                      <li>
                        <Link to="/price_data" className="font-size-14">
                          {this.props.t("Price List Info")}
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link to="/client_orders" className="font-size-14">
                        {this.props.t("Client Orders")}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Transfers Tab  */}
              {/* {perms.transferAgentAccess && ( */}

              {/* )} */}
              {/* Actividan Tab  */}
              {perms.actShippingAccess && (
                <li>
                  <Link to="/actividan_shipping" className="font-size-16">
                    <i className="fas fa-shipping-fast" />
                    <span>{this.props.t("Actividan Shipping")}</span>
                  </Link>
                </li>
              )}
              {/* Purchases Tab  */}
              {perms.purchaseRqstdPrdAccess && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-box" />
                    <span>{this.props.t("Purchase Order")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {profileData.department.depName !==
                      "Product Management Team" && (
                      <li>
                        <Link to="/products" className="font-size-14">
                          {this.props.t("Products to Order")}
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link to="/purchases" className="font-size-14">
                        {" "}
                        {this.props.t("Purchase List")}{" "}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {perms.logisticsAccess && (
                <li>
                  <Link to="/" className="font-size-16 has-arrow">
                    <i className="fas fa-road" />
                    <span>{this.props.t("Logistics")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/fees" className="font-size-14">
                        {" "}
                        {this.props.t("Logistics Fees")}{" "}
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {/* Statistics Tab  */}
              {(perms.statisticsGenAccess ||
                perms.statisticsSalesManAccess ||
                perms.statisticsAnalAccess) && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="mdi mdi-google-analytics" />
                    <span>Statistics</span>
                  </Link>
                  <ul className="sub-menu">
                    {perms.statisticsGenAccess && (
                      <li>
                        <Link to="/general" className="font-size-14">
                          {this.props.t("General Statistics")}
                        </Link>
                      </li>
                    )}
                    {perms.statisticsSalesManAccess && (
                      <li>
                        <Link to="/sales" className="font-size-14">
                          {" "}
                          {this.props.t("Sales Manager Statistics")}{" "}
                        </Link>
                      </li>
                    )}

                    {perms.statisticsAnalAccess && (
                      <li>
                        <Link to="/new_clients" className="font-size-14">
                          {" "}
                          {this.props.t("New Clients Analytics")}{" "}
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* Meeting Tab  */}
              {profileData.accType !== "Outsider" && (
                <li>
                  <Link to="/meeting_booking" className="font-size-16">
                    <i className="fas fa-calendar-plus" />
                    <span>{this.props.t("Meeting Room")}</span>
                  </Link>
                </li>
              )}
              {/* Admin Tabs */}
              {(profileData.accType === "Admin" || perms.notificationsAccess) && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-users" />
                    <span>{this.props.t("Admin")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {profileData.accType === "Admin" && (
                      <>
                        <li>
                          <Link to="/users" className="font-size-14">
                            {this.props.t("Users")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/overall-leaves" className="font-size-14">
                            {this.props.t("Overall Leaves")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/departments" className="font-size-14">
                            <span>{this.props.t("Departments")}</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/accesses" className="font-size-14">
                            <span>{this.props.t("Accesses")}</span>
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </li>
              )}
              {/* Marketing Department Tabs */}
              {(/*profileData.accType === "Admin" ||*/
                profileData.department.depName === "Marketing Team") && (
                <li>
                  <Link to="#" className="font-size-16 has-arrow">
                    <i className="fas fa-desktop" />
                    <span>{this.props.t("Marketing Department")}</span>
                  </Link>
                  <ul className="sub-menu">
                    {perms.domainsAccess && (
                      <li>
                        <Link to="/domains" className="font-size-14">
                          {this.props.t("Domains")}
                        </Link>
                      </li>
                    )}
                    {perms.domainsAccess && (
                      <li>
                        <Link to="/subs" className="font-size-14">
                          {this.props.t("Subscriptions")}
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            </ul>
          </div>
        </SimpleBar>
        <ReactDrawer
          open={this.state.open}
          className="drawer-open"
          position={this.state.position}
          onClose={this.onDrawerClose}
        >
          <UserProfile profileData={profileData} />
        </ReactDrawer>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
